import React from "react";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";

const SearchNoResult = (props) => {
    return (
        <>
            <Row>
                <Col>
                    <Typography tag="h2">No result is found.</Typography>
                </Col>
            </Row>
        </>
    );
}
export default SearchNoResult;